export default "__VITE_ASSET__ee31a886__"